<template lang="pug">
  div(:class="this.classes+' footer-container container-'+this._uid")
    //- div.parallaxContainer(v-parallax="0.2")
    div.bg-container
    #infoContainer
      span.footerMeta
        //- h2.title {{this.title}}
        //- div.logo(:style="'background-image: url(' + this.domainInfo.logo.file.url + ')'")
        router-link(:to="{ name: 'defaultScene', params: { path: '/' }}" class="brand logo medium" :style="'background-image: url(' + this.domainInfo.logoAlt.file.url + ')'" )
        //- span.subtitle {{this.title}}
      nav.footer-nav
        div.nav-items-container
          ol.nav-items
            li.item
              a(:href="'mailto:'+domainInfo.contact[0]") Contact
            li.item
              //- router-link(:to="{ name: 'pageScene', params: { path: '/privacy'}}") Privacy
              a(href="https://www.iubenda.com/privacy-policy/95107530" class="iubenda-nostyle no-brand iubenda-embed" title="Privacy Policy") Privacy Policy
            li.item
              a(href="https://www.iubenda.com/privacy-policy/95107530/cookie-policy" class="iubenda-nostyle no-brand iubenda-embed " title="Cookie Policy") Cookie Policy
          #copyright
            p © {{domainInfo.name}} {{this.date.getFullYear()}}

            //- li.item.button
            //-   a(href="mailto:info@digigurus.net") Privacy
    #newsletterContainer
      //- h6 {{this.desc}}
      //- span No spam, just relevant updates
      //- mcSubscribe(:action="this.payload.formAction")
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/sectionBase.js'
import mcSubscribe from '@/components/mcSubscribe.vue'
// import config from '@/config/global'

// component instance
var pageFooter = Vue.component('page-footer', {
  name: 'pageFooter',
  mixins: [sectionBase],
  props: ['domainInfo'],
  components: {mcSubscribe},
  data: function () {
    return {
      date: new Date()
    }
  },
  watch: {
  },
  methods: {
    handleSubmit (e) {
      // console.log('submitting newsletter form', e)
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default pageFooter
</script>

<style lang="scss" scoped>
  h4, h5, h6{
    position: relative;
    margin-bottom: 2rem;

    &:after{
      content: '';
      display: block;
      position: absolute;
      width: 34px;
      height: 1px;

      bottom: -10px;
      left: 0;

      background-color: get-color(primary);
      opacity: .6;
    }
  }

  a{
    text-decoration: underline;
  }
  .parallaxContainer{
    position: relative;
    z-index: -1;
    position: absolute;
    width: 120%;
    height: (#{measure(ml) + measure(m)});
    top: 8%;
    left: 0;
  }
  .bg-container{
    z-index: -1;
    position: absolute;
    width: 120%;
    height: 120%;
    top: 0%;
    left: $body-gutter;
    transform: rotate(8deg);
    transform-origin: top left;
    background-image: linear-gradient(35deg, #003BDC 40%, #5166E6 100%);
    border-radius: 120px 0 0 0;
  }

  .logo{
    height: measure(xs);
    margin-bottom: measure(sm);
  }

  .footer-container{
    position: relative;
    overflow: hidden;
    display: flex;
    padding: (#{measure(m) + measure(s)}) $body-gutter measure(xxs) calc(#{measure(xxs, true) + #{measure(xxs)}});

    margin: measure(sm) 0 0;

    flex-direction: row;

    @include breakpoint(small only) {
      flex-direction: column;
    }

    font-size: 90%;

    // border-top: 1px solid get-color(primary-min1)
  }

  #infoContainer{
    width: 100%;

    margin-bottom: measure(xxs);

    .footerMeta{
      display: block;
      margin-bottom: 2rem;

      line-height: 1.4;

      .title{
        text-transform: uppercase;
      }
      .subtitle{
        display: inline-block;
        text-transform: none;
        max-width: 340px
      }
    }
  }

  .footer-nav{
    li:first-child{
      margin-left: 0;
      // border-right: 2px solid $white;
    }
    li, li.item{
      padding: 0 !important;
    }
    li a, li.item a{
      background: transparent !important;
      border: none !important;
      padding: 0 !important;
      color: $white;
      font-weight: 700;
      text-decoration: underline;
    }
  }

  .nav-items-container{
    display: flex;
    flex: 1;
    justify-content: space-between;
  }

  #newsletterContainer{
    // flex: 1;
  }
  #newsletter{
    align-self: flex-start;
    position: relative;
    margin-top: 2rem;
  }

  #copyright{
    font-size: 80%;
    align-self: flex-end;
    // display: inline-block;
    color: $white;
  }
</style>



// WEBPACK FOOTER //
// src/components/sections/pageFooter.vue